import { FC, Fragment } from 'react';
import { Form, FormCheckboxProps, Tooltip } from '@servicetitan/design-system';

interface EnableMfaFormCheckboxProps<T> extends Omit<FormCheckboxProps<T>, 'label' | 'disabled'> {
    label?: FormCheckboxProps<T>['label'];
    isMfaEnabled?: boolean;
}

export const EnableMfaFormCheckbox = <T,>(
    props: EnableMfaFormCheckboxProps<T>
) => {
    const checkbox = (
        <div className="qa-mfa-checkbox">
            <Form.Checkbox
                description={
                    <span>
                        When enabled, this feature adds an extra layer of security by requiring a
                        second verification method. SMS verification will send a code to the{' '}
                        <strong>mobile phone number</strong> in this profile.
                    </span>
                }
                label="Enable Multi-Factor Authentification"
                disabled={props.isMfaEnabled}
                {...props}
            />
        </div>
    );

    if (props.isMfaEnabled) {
        return (
            <Tooltip
                hoverOnly
                text="Please contact your admin to remove the MFA from your account"
                direction="right"
            >
                {checkbox}
            </Tooltip>
        );
    }

    return (
        <Fragment>
            {checkbox}
        </Fragment>
    );
};
